function  Focus(id)
{
  document.getElementById(id).focus();
}


function  Click(id)
{
  document.getElementById(id).click();
}
